export default function DiscordIdentity({ discord, email, testId }) {
  if (!discord?.id) {
    return <span className="font-mono text-[11px] text-white/60 truncate" data-testid={testId}>{email || "NO DISCORD"}</span>;
  }
  const label = discord.global_name || discord.username || "DISCORD USER";
  return (
    <span className="flex min-w-0 items-center gap-2" data-testid={testId}>
      <img src={discord.avatar_url} alt="" className="h-7 w-7 shrink-0 border border-white/15 object-cover" />
      <span className="min-w-0">
        <span className="block truncate text-xs text-white">{label}</span>
        <span className="block truncate font-mono text-[9px] tracking-[0.1em] text-white/35">
          @{discord.username || "unknown"} · ID {discord.id}
        </span>
      </span>
    </span>
  );
}
